import axios from 'axios/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay, Callout, Intent } from "@blueprintjs/core";

export default class EnableWebpushModal extends PureComponent{

    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.props.showModal}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="separator" style={{position: 'absolute', top: 50, left: 0, width: '100%'}}></div>
                    <h3 style={{marginTop: -15, marginBottom: 30}}>Enable Webpush</h3>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">

                        <Callout icon='info-sign' intent={Intent.PRIMARY}>
                            Webpush is not enabled.
                        </Callout>
                        <p>Do you want to enable and set it up now?<br/>
                            It only take 10 minutes.</p>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                            <div style={{marginRight: 20}}>
                                <button
                                    disabled={ false }
                                    onClick={ () =>{
                                        this.props.handleClose()
                                    } }
                                    type="button"
                                    className='btn-transparent-border btn-sm m-sm-b center'>Cancel</button>
                            </div>
                            <div>
                                {this.props.loaderActive ?
                                    <button
                                        disabled={ true }
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn-action btn-sm m-sm-b center'>Enable <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button
                                        disabled={ false }
                                        onClick={ () =>{
                                            this.props.handleEnable()
                                        } }
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn-action btn-sm m-sm-b center'>Enable</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}